/**
 * app/components/FormLabel.tsx
 * -----------------------------
 * What: Small typography component for form field labels.
 * Why: Ensures consistent spacing and style across forms.
 */
import React from 'react';
import { Text, StyleSheet, TextProps } from 'react-native';
import { useTheme } from '../../lib/ThemeContext';

export default function FormLabel({ children, style, ...rest }: TextProps) {
  const { theme } = useTheme();
  return (
    <Text {...rest} style={[styles.label, { color: theme.secondaryText }, style]}>
      {children}
    </Text>
  );
}

const styles = StyleSheet.create({
  label: {
    fontSize: 14,
    fontWeight: '500',
    marginBottom: 6,
  },
}); 